import DOMPurify from "dompurify";

const OPTS = { ALLOWED_TAGS: ["p", "br", "strong", "b", "em", "i", "u", "s", "h2", "h3", "h4", "ul", "ol", "li", "a", "span", "blockquote", "hr", "mark"], ALLOWED_ATTR: ["href", "target", "rel", "style"] };

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") { node.setAttribute("target", "_blank"); node.setAttribute("rel", "noopener noreferrer"); }
});

export const NoticeContent = ({ html, testId = "notice-content" }) => (
  <div className="rich-content" data-testid={testId} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html || "", OPTS) }} />
);
